import React, { FC, HTMLAttributes } from 'react';
import { cn } from '../../../helpers';
import popupButtonsStyles from './popupbuttons.module.scss';

/**
 * PopupButtons
 */
export const PopupButtons: FC<HTMLAttributes<HTMLElement>> = ({ className, children, ...props }) => {
    const classNames = cn(popupButtonsStyles.popup_footer, 'd-flex flex-column flex-sm-row justify-content-end', {
        [className]: className,
    });

    return (
        <div className={classNames} {...props}>
            {children}
        </div>
    );
};
